import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatTableModule } from '@angular/material/table'
import { MatTooltipModule } from '@angular/material/tooltip'
import { RouterModule } from '@angular/router'
import { PipesModule } from '@mmx/pipes'
import { DirectivesModule } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { AppointmentPortalMenuModule } from '../appointment-portal-menu'
import { AuthorizationDialogModule } from '../authorization-dialog'
import { BreadcrumbModule } from '../breadcrumb'
import { CopyTextModule } from '../copy-text'
import { InsuranceDialogModule } from '../insurance-dialog'
import { PatientAuthHistoryDialogModule } from '../patient-auth-history-dialog'
import { PatientFileViewModule } from '../patient-file-view'
import { ServiceReviewInquiryModule } from '../service-review-inquiry'
import { ServiceReviewSubmissionModule } from '../service-review-submission'
import { StatusIconsModule } from '../status-icons'
import { AuthorizationCardComponent } from './authorization-card.component'

@NgModule({
  declarations: [
    AuthorizationCardComponent,
  ],
  imports: [
    AppointmentPortalMenuModule,
    AuthorizationDialogModule,
    BreadcrumbModule,
    CommonModule,
    CopyTextModule,
    DirectivesModule,
    FlexLayoutModule,
    InsuranceDialogModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatProgressBarModule,
    MatTableModule,
    MatTooltipModule,
    PatientAuthHistoryDialogModule,
    PatientFileViewModule,
    PipesModule,
    RouterModule,
    ServiceReviewInquiryModule,
    ServiceReviewSubmissionModule,
    StatusIconsModule,
    TranslateModule,
  ],
  exports: [AuthorizationCardComponent],
})
export class AuthorizationCardModule {}
